import { CATEGORY_COLORS } from './categoryColors';

/**
 * Category per skill key, mirroring the `category` frontmatter of the
 * SKILL.md folders in python-ai-service (drift-checked by the sibling test)
 * so chat rendering doesn't depend on the entitlements API being loaded.
 */
export const SKILL_CATEGORIES: Record<string, string> = {
  rhino_desktop: 'CAD',
  rhino_compute: 'CAD',
  blender: 'CAD',
  freecad: 'CAD',
  model_to_2d: 'CAD',
  fusion: 'CAD',
  catia: 'CAD',
  solidworks: 'CAD',
  cadquery: 'Coding',
  cad_studio: 'CAD',
  drawing_to_3d: 'CAD',
  vectorize_scan: 'CAD',
  defeature: 'CAD',
  pymeshlab: 'Coding',
  abaqus: 'CAE',
  fets: 'CAE',
  paraview: 'CAE',
  cam: 'CAM',
  prusaslicer: 'CAM',
  cura: 'CAM',
  image_gen: 'AI',
  '3d_gen': 'AI',
  search: 'AI',
};

export type SkillAccentColorFn = (skillKey: string, isLight: boolean) => string | undefined;
export type SkillCategoryFn = (skillKey: string) => string | undefined;

export const skillCategory: SkillCategoryFn = (skillKey) =>
  SKILL_CATEGORIES[skillKey.toLowerCase()];

export const skillAccentColor: SkillAccentColorFn = (skillKey, isLight) => {
  const category = skillCategory(skillKey);
  const pair = category ? CATEGORY_COLORS[category] : undefined;
  if (!pair) return undefined;
  return isLight ? pair.light : pair.dark;
};
